(() => {
  if (window.__nuvialleProductCard) return;
  window.__nuvialleProductCard = true;

  const formatMoney = (cents, format) => {
    const value = (Number(cents) || 0) / 100;
    const withDelim = (n, dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        default: return withDelim(value, 2, ',', '.');
      }
    });
  };

  const init = (root) => {
    if (!root || root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const money = (c) => formatMoney(c, root.dataset.moneyFormat);
    const addLabel = root.dataset.addLabel || 'Add to Cart';
    const soldOutLabel = root.dataset.soldoutLabel || 'Sold out';
    const addingLabel = root.dataset.addingLabel || 'Adding…';

    /* ---------- Gallery ---------- */
    const stage = $('[data-nv-pc-stage]');
    const slides = $$('[data-nv-pc-slide]');
    const thumbs = $$('[data-nv-pc-thumb]');
    let current = 0;
    const setActive = (index) => {
      current = index;
      thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.index) === index));
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === index) video.play().catch(() => {});
        else video.pause();
      });
    };
    const goTo = (index) => {
      const slide = slides[index];
      if (!slide || !stage) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      setActive(index);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
    const visibleSlides = () => slides.filter((s) => s.style.display !== 'none').sort((a, b) => a.offsetLeft - b.offsetLeft);
    const step = (dir) => {
      const vis = visibleSlides();
      if (!vis.length) return;
      const pos = Math.max(0, vis.indexOf(slides[current]));
      goTo(slides.indexOf(vis[(pos + dir + vis.length) % vis.length]));
    };
    $('[data-nv-pc-prev]')?.addEventListener('click', () => step(-1));
    $('[data-nv-pc-next]')?.addEventListener('click', () => step(1));
    if (stage && slides.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => e.isIntersecting && e.intersectionRatio >= 0.6 && setActive(Number(e.target.dataset.index))),
        { root: stage, threshold: [0.6] }
      );
      slides.forEach((s) => io.observe(s));
    }
    /* Variant media: images whose alt contains an option value (e.g. "candy-bear") belong to that
       variant; without such alts, each variant's own featured image does. Shared images always show. */
    const valueKeys = (root.dataset.valueKeys || '').split(',').filter(Boolean);
    const featuredIds = (root.dataset.featuredIds || '').split(',').filter(Boolean);
    const altMatches = (alt, key) => !!alt && !!key && `-${alt}-`.includes(`-${key}-`);
    const altVariant = (el) => valueKeys.some((k) => altMatches(el.dataset.alt || '', k));
    const altGroups = slides.some(altVariant);
    const useFeatured = !altGroups && featuredIds.length > 0;
    const isVariantMedia = (el) => (altGroups ? altVariant(el) : useFeatured && featuredIds.includes(el.dataset.mediaId || ''));
    const matchesVariant = (el, keys, mediaId) =>
      altGroups ? keys.some((k) => altMatches(el.dataset.alt || '', k)) : useFeatured && !!mediaId && el.dataset.mediaId === String(mediaId);
    const thumbFor = (slide) => thumbs.find((t) => t.dataset.index === slide.dataset.index);

    // The same shared photo uploaded twice gets a uuid suffix — show it once.
    const mediaKey = (el) => {
      const img = el.querySelector('img');
      const src = (img ? img.getAttribute('src') || '' : '').split('?')[0];
      return src.slice(src.lastIndexOf('/') + 1).toLowerCase().replace(/\.[a-z0-9]+$/, '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
    };
    const seenMedia = new Set();
    slides.forEach((slide) => {
      if (isVariantMedia(slide)) return;
      const key = mediaKey(slide);
      if (!key) return;
      if (!seenMedia.has(key)) return seenMedia.add(key);
      slide.dataset.dupe = '1';
      slide.style.display = 'none';
      const th = thumbFor(slide);
      if (th) th.style.display = 'none';
    });

    const showMedia = (mediaId, keys = []) => {
      if (!altGroups && !useFeatured) {
        const index = mediaId ? slides.findIndex((s) => s.dataset.mediaId === String(mediaId)) : -1;
        if (index >= 0) goTo(index);
        return;
      }
      slides.forEach((slide) => {
        const shown = slide.dataset.dupe !== '1' && (!isVariantMedia(slide) || matchesVariant(slide, keys, mediaId));
        const order = shown ? (isVariantMedia(slide) ? '0' : '1') : '';
        slide.style.display = shown ? '' : 'none';
        slide.style.order = order;
        const th = thumbFor(slide);
        if (th) {
          th.style.display = shown ? '' : 'none';
          th.style.order = order;
        }
      });
      const vis = visibleSlides();
      const target = vis.find((s) => isVariantMedia(s) && matchesVariant(s, keys, mediaId)) || vis.find((s) => mediaId && s.dataset.mediaId === String(mediaId)) || vis[0];
      if (target) goTo(slides.indexOf(target));
    };
    showMedia(root.dataset.initialMediaId, (root.dataset.initialKeys || '').split(',').filter(Boolean));

    /* ---------- Variant state ---------- */
    const idInput = $('[data-nv-pc-id]');
    const priceEl = $('[data-nv-pc-price]');
    const compareEl = $('[data-nv-pc-compare]');
    const nameEl = $('[data-nv-pc-variant-name]');
    const atc = $('[data-nv-pc-atc]');
    const atcLabel = $('[data-nv-pc-atc-label]');
    const errorEl = $('[data-nv-pc-error]');

    let updateVolume = () => {};
    const applyVariant = ({ id, price, compare, available, name, mediaId, altKeys }) => {
      if (idInput) idInput.value = id;
      updateVolume({ id, available });
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        const showCompare = Number(compare) > Number(price);
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = money(compare);
      }
      if (nameEl && name) nameEl.textContent = name;
      if (atc) {
        atc.disabled = !available;
        if (atcLabel) atcLabel.textContent = available ? addLabel : soldOutLabel;
      }
      if (errorEl) errorEl.hidden = true;
      showMedia(mediaId, altKeys || []);
      if (id && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
    };

    /* ---------- Single option: dropdown + roundels ---------- */
    const dd = $('[data-nv-pc-dd]');
    const toggle = $('[data-nv-pc-dd-toggle]');
    const panel = $('[data-nv-pc-dd-panel]');
    const roundels = $$('[data-nv-pc-roundel]');

    const positionPanel = () => {
      if (!toggle || !panel || panel.hidden) return;
      const r = toggle.getBoundingClientRect();
      const below = window.innerHeight - r.bottom;
      panel.style.left = `${r.left}px`;
      panel.style.width = `${r.width}px`;
      if (below < 220 && r.top > below) {
        const h = Math.min(320, r.top - 8);
        panel.style.maxHeight = `${h}px`;
        panel.style.top = `${r.top - 8 - h}px`;
      } else {
        panel.style.maxHeight = `${Math.min(320, below - 8)}px`;
        panel.style.top = `${r.bottom + 6}px`;
      }
    };
    const closePanel = () => {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };
    const openPanel = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      positionPanel();
      (panel.querySelector('.is-selected') || panel.querySelector('[data-nv-pc-option]'))?.focus({ preventScroll: true });
    };

    const selectRoundel = (roundel) => {
      if (!roundel) return;
      const id = roundel.dataset.variantId;
      roundels.forEach((r) => {
        const on = r === roundel;
        r.classList.toggle('is-selected', on);
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-nv-pc-option]').forEach((opt) => {
        const on = opt.dataset.variantId === id;
        opt.classList.toggle('is-selected', on);
        opt.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      const swatch = roundel.querySelector('img');
      const ddSwatch = toggle?.querySelector('.nv-pc-dd__swatch');
      if (ddSwatch) ddSwatch.innerHTML = swatch ? `<img src="${swatch.currentSrc || swatch.src}" alt="" width="30" height="30">` : '';
      applyVariant({
        id,
        price: roundel.dataset.price,
        compare: roundel.dataset.compare,
        available: roundel.dataset.available === 'true',
        name: roundel.dataset.name,
        mediaId: roundel.dataset.mediaId,
        altKeys: (roundel.dataset.altKeys || '').split(',').filter(Boolean),
      });
    };

    roundels.forEach((r) => r.addEventListener('click', () => selectRoundel(r)));
    if (toggle && panel) {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        if (panel.hidden) openPanel();
        else closePanel();
      });
      $$('[data-nv-pc-option]').forEach((opt) =>
        opt.addEventListener('click', () => {
          selectRoundel(roundels.find((r) => r.dataset.variantId === opt.dataset.variantId));
          closePanel();
          toggle.focus({ preventScroll: true });
        })
      );
      panel.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const opts = $$('[data-nv-pc-option]');
        const i = opts.indexOf(document.activeElement);
        opts[(i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length]?.focus();
      });
      document.addEventListener('click', (e) => { if (dd && !dd.contains(e.target)) closePanel(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });
      window.addEventListener('resize', positionPanel);
      window.addEventListener('scroll', positionPanel, { passive: true, capture: true });
    }

    /* ---------- Multiple options: pills ---------- */
    const multi = $('[data-nv-pc-multi]');
    if (multi) {
      let variants = [];
      try { variants = JSON.parse(multi.querySelector('[data-nv-pc-variants]').textContent); } catch (err) { variants = []; }
      const groups = $$('[data-nv-pc-optgroup]');
      const selected = groups.map((g) => g.querySelector('.is-selected')?.dataset.value);
      const findVariant = (sel) => variants.find((v) => v.options.every((o, i) => o === sel[i]));
      const refreshAvailability = () => {
        $$('[data-nv-pc-optvalue]').forEach((btn) => {
          const oi = Number(btn.dataset.optionIndex);
          const trial = selected.slice();
          trial[oi] = btn.dataset.value;
          const v = findVariant(trial);
          btn.toggleAttribute('data-unavailable', !v || !v.available);
        });
      };
      $$('[data-nv-pc-optvalue]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const oi = Number(btn.dataset.optionIndex);
          selected[oi] = btn.dataset.value;
          const group = groups[oi];
          group.querySelectorAll('[data-nv-pc-optvalue]').forEach((b) => b.classList.toggle('is-selected', b === btn));
          const label = group.querySelector('[data-nv-pc-opt-selected]');
          if (label) label.textContent = btn.dataset.value;
          const v = findVariant(selected);
          if (v) applyVariant({ ...v, name: v.options.join(' / ') });
          else if (atc) {
            atc.disabled = true;
            if (atcLabel) atcLabel.textContent = soldOutLabel;
          }
          refreshAvailability();
        })
      );
      refreshAvailability();
    }

    /* ---------- Quantity ---------- */
    const qtyInput = $('[data-nv-pc-qty-input]');
    $$('[data-nv-pc-qty]').forEach((btn) =>
      btn.addEventListener('click', () => {
        const val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val + Number(btn.dataset.nvPcQty));
      })
    );
    qtyInput?.addEventListener('change', () => {
      const val = parseInt(qtyInput.value, 10);
      qtyInput.value = Number.isNaN(val) || val < 1 ? 1 : val;
    });

    /* ---------- Free gift progress ---------- */
    const gwp = $('[data-nv-pc-gwp]');
    let refreshGift = () => {};
    if (gwp) {
      const threshold = Number(gwp.dataset.thresholdCents) || 0;
      const fill = gwp.querySelector('[data-nv-pc-gwp-fill]');
      const msg = gwp.querySelector('[data-nv-pc-gwp-msg]');
      const update = (total) => {
        if (!threshold) return;
        if (fill) fill.style.width = `${Math.max(0, Math.min(100, (total / threshold) * 100))}%`;
        const remaining = Math.max(0, threshold - total);
        gwp.classList.toggle('is-unlocked', remaining === 0);
        if (msg) msg.textContent = remaining === 0 ? gwp.dataset.unlockedMsg : gwp.dataset.msg.replace('[remaining]', money(remaining));
      };
      refreshGift = (cart) => {
        if (cart && typeof cart.total_price === 'number') return update(cart.total_price);
        const root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root_url}cart.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => update(c.total_price))
          .catch(() => {});
      };
      requestAnimationFrame(() => refreshGift());
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => refreshGift());
      }
      document.addEventListener('nuvialle:item-added', () => refreshGift());

      const modal = gwp.querySelector('[data-nv-pc-gwp-modal]');
      const opener = gwp.querySelector('[data-nv-pc-gwp-open]');
      if (modal && opener) {
        const close = () => {
          modal.hidden = true;
          opener.focus({ preventScroll: true });
        };
        opener.addEventListener('click', () => {
          modal.hidden = false;
          modal.querySelector('[data-nv-pc-gwp-close].nv-pc-gwp__modal-close')?.focus({ preventScroll: true });
        });
        modal.querySelectorAll('[data-nv-pc-gwp-close]').forEach((b) => b.addEventListener('click', close));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
      }
    }

    /* ---------- Add to cart (AJAX, then the theme cart drawer) ---------- */
    const addToCart = async (body, isJson) => {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = ['cart-icon-bubble'].concat(cartDrawer ? ['cart-drawer'] : []).join(',');
      const headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      if (isJson) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
        headers['Content-Type'] = 'application/json';
      } else {
        body.append('sections', sections);
        body.append('sections_url', window.location.pathname);
      }
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(`${addUrl}.js`, { method: 'POST', headers, body: isJson ? JSON.stringify(body) : body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nuvialle-product-card', productVariantId: data.variant_id, cartData: data });
      }
      document.dispatchEvent(new CustomEvent('nuvialle:item-added', { detail: data }));
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
        refreshGift();
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    };
    const showError = (err) => {
      if (!errorEl) return;
      errorEl.textContent = err.message;
      errorEl.hidden = false;
    };

    const form = root.querySelector('.nv-pc-form');
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      atc.disabled = true;
      if (atcLabel) atcLabel.textContent = addingLabel;
      if (errorEl) errorEl.hidden = true;
      try {
        await addToCart(new FormData(form), false);
      } catch (err) {
        showError(err);
      } finally {
        atc.disabled = false;
        if (atcLabel) atcLabel.textContent = addLabel;
      }
    });

    /* ---------- Buy More, Save More ---------- */
    const volume = $('[data-nv-pc-volume]');
    if (volume) {
      const tiers = [...volume.querySelectorAll('[data-nv-pc-tier]')];
      const picker = volume.querySelector('[data-nv-pc-volume-picker]');
      const saveEl = volume.querySelector('[data-nv-pc-volume-save]');
      const addBtn = volume.querySelector('[data-nv-pc-volume-add]');
      const optionLabel = volume.dataset.optionLabel || 'Option';
      let variants = [];
      try { variants = JSON.parse(volume.querySelector('[data-nv-pc-volume-variants]').textContent); } catch (err) { variants = []; }
      const byId = new Map(variants.map((v) => [String(v.id), v]));
      const defaultTier = tiers.find((t) => t.hasAttribute('data-default')) || tiers[tiers.length - 1];
      const chosenTier = () => tiers.find((t) => t.querySelector('input').checked);
      const activeTier = () => chosenTier() || defaultTier;
      const pickerIds = () => (picker && !picker.hidden ? [...picker.querySelectorAll('select')].map((s) => s.value) : []);
      const idsFor = (tier) => {
        const qty = Number(tier.dataset.qty);
        const picked = tier === chosenTier() ? pickerIds() : [];
        return picked.length === qty ? picked : Array(qty).fill(String(idInput.value));
      };

      const renderPrices = () => {
        tiers.forEach((tier) => {
          const was = idsFor(tier).reduce((sum, id) => sum + ((byId.get(id) || {}).price || 0), 0);
          const now = Math.round((was * (100 - Number(tier.dataset.pct))) / 100);
          tier.querySelector('[data-nv-pc-tier-now]').textContent = money(now);
          tier.querySelector('[data-nv-pc-tier-was]').textContent = money(was);
        });
        if (saveEl) saveEl.textContent = `( Save ${activeTier().dataset.pct}% )`;
      };

      const buildPicker = (reset) => {
        const tier = chosenTier();
        if (!picker || !tier || variants.length < 2) {
          if (picker) picker.hidden = true;
          return;
        }
        const qty = Number(tier.dataset.qty);
        const previous = [...picker.querySelectorAll('select')].map((s) => s.value);
        picker.innerHTML = '';
        for (let i = 0; i < qty; i++) {
          const row = document.createElement('label');
          row.className = 'nv-pc-volume__pick';
          const text = document.createElement('span');
          text.textContent = `${optionLabel} ${i + 1}:`;
          const select = document.createElement('select');
          variants.forEach((v) => {
            const opt = new Option(v.title, v.id);
            opt.disabled = !v.available;
            select.add(opt);
          });
          select.value = (!reset && previous[i]) || String(idInput.value);
          select.addEventListener('change', renderPrices);
          row.append(text, select);
          picker.appendChild(row);
        }
        picker.hidden = false;
      };

      tiers.forEach((tier) =>
        tier.querySelector('input').addEventListener('change', () => {
          tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
          buildPicker();
          renderPrices();
        })
      );

      updateVolume = ({ available }) => {
        if (picker && !picker.hidden) buildPicker(true);
        renderPrices();
        if (addBtn) addBtn.disabled = !available;
      };

      addBtn?.addEventListener('click', async () => {
        const counts = new Map();
        idsFor(activeTier()).forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
        addBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        try {
          await addToCart({ items: [...counts].map(([id, quantity]) => ({ id: Number(id), quantity })) }, true);
        } catch (err) {
          showError(err);
        } finally {
          addBtn.disabled = false;
        }
      });

      renderPrices();
    }
  };

  const boot = () => document.querySelectorAll('[data-nv-pc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-nv-pc]')));
})();
